import { Select } from "antd";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";

interface IProps {
  eduStepCode: string|undefined;
  setEduStepCode: (eduStepCode: string) => void;
  placeholder?: string;
  width?: number;
  includeAll?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  noDefault?: boolean;
};

const SelectEduStep: FC<IProps> = ({
  eduStepCode,
  setEduStepCode,
  placeholder,
  width = 100,
  includeAll = false,
  fullWidth = false,
  disabled = false,
  noDefault = false,
}) => {
  const { t, i18n } = useTranslation();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // PR0006 = 교육단계
  const PR0006 = commonCodes.find(item => item.commonCode === 'PR0006')?.detailCode;

  useEffect(() => {
    if (PR0006 && !eduStepCode && !includeAll && !noDefault) {
      setEduStepCode(PR0006[0].detailCode);
    }
  }, [PR0006]);

  return (
    <div>
      <Select
        placeholder={placeholder || t('common.placeholder.1')}
        value={eduStepCode}
        onChange={value => setEduStepCode(value)}
        disabled={disabled}
      >
        {includeAll && (
          <Select.Option value="">
            {t('common.text.all')}
          </Select.Option>
        )}
        {PR0006?.map(item => (
          <Select.Option
            key={item.detailCode}
            value={item.detailCode}
          >
            {i18n.language === 'ko' ? item.korName : item.engName}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};

export default SelectEduStep;
